module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-dialog', {
    attrs: {
      "mshow": _vm.mergeRuleShow,
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "beast-login-warp merge"
  }, [_c('div', {
    staticClass: "merge-main"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("./assets/close.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/wtf.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("相关说明")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "merge-rule"
  }, [_c('div', [_c('p', [_vm._v("Q：账户合并会牵涉哪些项目合并？")]), _vm._v(" "), _c('p', [_vm._v("A：会员的基础信息、等级信息、所有历史订单以及账户内所有的会员福利等，合并流程不可逆。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：生日信息的合并方法？")]), _vm._v(" "), _c('p', [_vm._v("A：会以当前登录账号为准；若当前账户生日为空，则取子账号生日。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：合并后的会员等级怎么计算？")]), _vm._v(" "), _c('p', [_vm._v("A：会员等级和有效期会取多个账户中等级较高的一个。如果合并后，12个月的总消费满足升级条件，会在次日统一升级。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：会员账户内的优惠券，以及相关权益如何合并？")]), _vm._v(" "), _c('p', [_vm._v("A：已领取的所有优惠券和权益都会进行合并；可在个人中心内查看并使用。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：账户内还有未领取的会员礼包？")]), _vm._v(" "), _c('p', [_vm._v("A：如果还有未领取的会员礼包，我们会将礼包统一发放至您当前登录账户中。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：被合并的账户不是我的？")]), _vm._v(" "), _c('p', [_vm._v("A：可以通过在线客服反映，我们会尽快核实并处理。")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eed6456"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-login/merge-rule.vue
// module id = 117
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 20 21 22 23 25 26 29 30 31 32 34 35 36 38 41 42 43 45 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63